import { dateCol, intCol } from '@integec/grid-tools/lib/cols'
import { getUniversalIdInfo } from 'api/pgads.js'
import { getApiTargetInfo } from 'core'
import {
  modifiedDateCol,
  modifierCol,
  utilityHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import { getUnitNameMap, getUtilityNameMap } from 'core/selectors'
import React from 'react'
import { connect } from 'react-redux'
import CommonScreen from './CommonScreen'

const headers = [
  intCol({ ident: 'universalId', display: 'Universal ID', isKey: true }),
  utilityHeader,
  unitHeader,

  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    width: 200,
  }),
  dateCol({
    ident: 'endDate',
    display: 'End Date',
    isEditable: false,
    isKey: true,
  }),
  intCol({
    ident: 'region',
    display: 'Region',
    isEditable: false,
    isKey: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getUniversalIdInfo(apiTargetInfo)

const title = 'Universal ID'

const UniversalId = ({ utilityNameMap, unitNameMap }) => {
  const headerWithFormatter = headers.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
          width: 300,
        }
      : header.ident === 'unit'
      ? {
          ...header,
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          width: 300,
        }
      : header
  )

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      retrieveTask={retrieveTask}
      altBy={d => d.universalId}
      autoRetrieve
      sortOptions={[
        { ident: 'universalId', display: 'Universal ID', sortOrder: 'asc' },
      ]}
      withoutModify
      allowInsert={false}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
})

export default connect(mapStateToProps)(UniversalId)
